/** F606 Orders page — bridge-backed. */
import { ShoppingBag } from 'lucide-react';
import F606DataPage from './F606DataPage';

const STATUS_LABELS = {
  pending:    { ar: 'قيد الانتظار', color: 'bg-amber-500/15 text-amber-300 border-amber-500/40' },
  confirmed:  { ar: 'مؤكد',         color: 'bg-blue-500/15 text-blue-300 border-blue-500/40' },
  preparing:  { ar: 'قيد التجهيز',  color: 'bg-purple-500/15 text-purple-300 border-purple-500/40' },
  processing: { ar: 'قيد التجهيز',  color: 'bg-purple-500/15 text-purple-300 border-purple-500/40' },
  shipped:    { ar: 'تم الشحن',     color: 'bg-cyan-500/15 text-cyan-300 border-cyan-500/40' },
  delivered:  { ar: 'تم التوصيل',   color: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40' },
  cancelled:  { ar: 'ملغي',         color: 'bg-red-500/15 text-red-300 border-red-500/40' },
  refunded:   { ar: 'مسترجع',       color: 'bg-white/5 text-white/50 border-white/10' },
};

export default function F606OrdersPage() {
  return (
    <F606DataPage
      entity="orders"
      titleAr="طلبات المتجر"
      titleEn="Store orders"
      icon={ShoppingBag}
      emptyIcon={ShoppingBag}
      columns={[
        {
          key: 'order_number',
          ar: 'رقم الطلب', en: 'Order #',
          render: (r) => <span className="font-mono text-white font-bold" dir="ltr">#{r.order_number || String(r.id || '').slice(0, 8)}</span>,
          className: 'w-32',
        },
        {
          key: 'buyer_name',
          ar: 'العميل', en: 'Customer',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.buyer_name || r.customer_name || r.user_name || '—'}</div>
              {(r.buyer_email || r.customer_email) && (
                <div className="text-[10px] text-white/40" dir="ltr">{r.buyer_email || r.customer_email}</div>
              )}
            </div>
          ),
        },
        {
          key: 'total',
          ar: 'الإجمالي', en: 'Total',
          render: (r) => r.total != null ? <span className="font-mono font-bold text-emerald-300" dir="ltr">{Number(r.total).toFixed(2)} {r.currency || 'AED'}</span> : '—',
          className: 'w-32',
        },
        {
          key: 'status',
          ar: 'الحالة', en: 'Status',
          render: (r) => {
            const s = STATUS_LABELS[r.status] || STATUS_LABELS.pending;
            return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold border ${s.color}`}>{s.ar}</span>;
          },
          className: 'w-28',
        },
        {
          key: 'created_at',
          ar: 'التاريخ', en: 'Date',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleString() : '—',
          className: 'w-40 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
